"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncatedSVGText = void 0;
var react_1 = __importStar(require("react"));
var TruncatedSVGText = function (_a) {
    var _b;
    var text = _a.text, textContainerRef = _a.textContainerRef, widthRef = _a.widthRef, _c = _a.widthOffset, widthOffset = _c === void 0 ? 0 : _c;
    var textRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(false), isTextTruncated = _d[0], setIsTextTruncated = _d[1];
    (0, react_1.useEffect)(function () {
        var truncateText = function () {
            var _a;
            var element = textRef.current;
            if (!element)
                return;
            var currentText = text;
            var textWidth = textContainerRef.current.getComputedTextLength();
            var totWidth = ((_a = widthRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) + widthOffset;
            // Check if truncation is needed
            if (textWidth > totWidth) {
                setIsTextTruncated(true);
                while (textWidth > totWidth && currentText.length > 0) {
                    currentText = currentText.slice(0, -1);
                    element.textContent = currentText + '...';
                    textWidth = textContainerRef.current.getComputedTextLength();
                }
            }
        };
        truncateText();
    }, [text, (_b = widthRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width]);
    return (react_1.default.createElement("tspan", { ref: textRef, onMouseOver: function () { return console.log(text); } }, text));
};
exports.TruncatedSVGText = TruncatedSVGText;
